module.exports = __webpack_public_path__ + "img/vertical-divider.6ed1c227.svg";